module.exports = __webpack_public_path__ + "static/img/header5.b67a0683.jpg";